import { actionTypes } from './constants';
import { getApiActionCreator } from 'helpers/actionHelper';

export const refreshGatewayAction = getApiActionCreator(actionTypes.REFRESH_GATEWAY_SETTINGS);

export const refreshGateway = (gatewayID) => {
    return {
        type: actionTypes.REFRESH_GATEWAY,
        gatewayID
    };
};

export const clearStore = () => {
    return {
        type: actionTypes.CLEAR_STORE
    };
};
